import { useTranslation } from 'react-i18next';

import { Badge, MantineColor } from '@any-ui-react/core';

import { BroadcastStatus } from '@anyx/common-graphql';

interface BroadcastStatusTagProps {
  status: BroadcastStatus;
}

const getStatusColor = (status: BroadcastStatus): MantineColor => {
  const BroadcastStatusColors: Record<BroadcastStatus, MantineColor> = {
    [BroadcastStatus.DRAFT]: 'yellow',
    [BroadcastStatus.SCHEDULED]: 'blue',
    [BroadcastStatus.DELIVERED]: 'green',
    [BroadcastStatus.ERROR]: 'red',
    [BroadcastStatus.SENDING]: 'gray',
  };
  return BroadcastStatusColors[status];
};

export const BroadcastStatusTag = ({ status }: BroadcastStatusTagProps) => {
  const { t } = useTranslation('gql');

  return <Badge color={getStatusColor(status)}>{t('gql.enum.broadcastStatus', { status })}</Badge>;
};
